import _Object$getOwnPropertySymbols from "core-js/library/fn/object/get-own-property-symbols.js";
import objectWithoutPropertiesLoose from "./objectWithoutPropertiesLoose.js";
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = objectWithoutPropertiesLoose(e, t);
  if (_Object$getOwnPropertySymbols) {
    var s = _Object$getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) {
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
  }
  return i;
}
export { _objectWithoutProperties as default };